import { Injectable }  from '@angular/core';
import { Http, Response } from '@angular/http';
import { environment } from '../environments/environment';
import { IAppConfig } from 'src/Models/app-config.model';

@Injectable()
export class AppConfig {

  static settings: IAppConfig;

  constructor(private readonly http: Http) { }

  load() {
    AppConfig.settings = {
    env: {
      name: environment.name
    },
    ConnectionStrings: {
      ClientSecret: environment.ClientSecret,
      ClientID: environment.ClientID,
      BaseURL: environment.BaseURL
    }
  };
  }
}
